<template>
  <div class="gift-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t("sale.gift.title1") }}</span>
      <span v-else>编辑礼品卡</span>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="120px"
          :model="gift"
          @submit.native.prevent
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item :label="$t('sale.gift.theme')" prop="title">
            <el-input
              v-model="gift.title"
              class="fl"
              style="width: 100%"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('sale.gift.startAt')" prop="startAt">
            <el-date-picker
              type="datetime"
              :placeholder="$t('sale.gift.inputStartAt')"
              v-model="gift.startAt"
              :picker-options="startDatePicker"
              style="width: 200px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('sale.gift.endAt')" prop="endAt">
            <el-date-picker
              type="datetime"
              :placeholder="$t('sale.gift.inputEndAt')"
              v-model="gift.endAt"
              :picker-options="endDatePicker"
              style="width: 200px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="活动平台" prop="source">
            <el-radio-group v-model="gift.source">
              <el-radio label="wechat">微信</el-radio>
              <el-radio label="jd">京东</el-radio>
              <el-radio label="weibo">微博</el-radio>
              <el-radio label="tianmao">天猫</el-radio>
              <el-radio label="pdd">拼多多</el-radio>
              <el-radio label="youzan">有赞</el-radio>
              <el-radio label="suning">苏宁</el-radio>
              <el-radio label="zhihu">知乎</el-radio>
              <el-radio label="qqQun">QQ群</el-radio>
              <el-radio label="wexinQun">微信群</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="'获取方式'">
            <el-input v-model="gift.getType"></el-input>
          </el-form-item>
          <el-form-item :label="'领取提示'">
            <el-input v-model="gift.tips"></el-input>
          </el-form-item>
          <el-form-item :label="'活动描述'">
            <el-input
              v-model="gift.description"
              class="fl"
              type="textarea"
              :rows="2"
              resize="nuno"
              style="width: 100%"
            ></el-input>
          </el-form-item>
          <div v-if="!$route.query.id">
            <el-form-item :label="'用户'" v-if="userInfo.roleValue === 1">
              <!-- <el-input
                v-model="gift.phoneList"
                class="fl"
                placeholder="手机号码，多个用回车键区分"
                type="textarea"
                :rows="2"
                resize="nuno"
                style="width: 100%"
              ></el-input> -->
              <el-upload
                class="fl"
                action=""
                :auto-upload="false"
                :on-change="importPhone"
                :show-file-list="false"
              >
                <span class="gift-mgt-fileName" v-if="userFile">{{
                  userFile.name
                }}</span>
                <el-button size="small" type="primary">导入</el-button>
              </el-upload>
            </el-form-item>

            <el-form-item :label="'选择卡片'">
              <el-checkbox-group v-model="gift.cardHolders" @change="changeCheck">
                <el-checkbox :label="item.id" v-for="(item, index) in useList" :key="index">{{item.lable}}({{item.value}})</el-checkbox>
              </el-checkbox-group>
              <span v-if="useList.length===0">暂无</span>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["userInfo"])
  },
  data() {
    return {
      gift: {
        title: "",
        source: "wechat",
        startAt: "",
        endAt: "",
        tips: "",
        getType: "",
        description: "",
        cardHolders: []
      },
      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate(),
      userFile: null,
      useList: [],
      rules: {
        codeList: [
          {
            required: true,
            message: "礼品卡号不能为空",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "礼品卡号不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.getUseList()
  },
  methods: {
    beginDate(){
      const self = this
      return {
        disabledDate(time){
          if (self.gift.endAt) {  //如果结束时间不为空，则小于结束时间
            return new Date(self.gift.endAt).getTime() < time.getTime()
          } else {
            return time.getTime() < Date.now() - 1000*3600*24 //开始时间不选时，结束时间最大值小于等于当天
          }
        }
      }
    },
    processDate() {
      const  self = this
      return {
        disabledDate(time) {
          if (self.gift.startAt) {  //如果开始时间不为空，则结束时间大于开始时间,且大于当前时间
            return new Date(self.gift.startAt).getTime() > time.getTime() || time.getTime() < Date.now() - 1000*3600*24
          } else {
            return time.getTime() < Date.now() - 1000*3600*24//开始时间不选时，结束时间最大值大于等于当天
          }
        }
      }
    },
    importPhone(file) {
      this.userFile = file;
    },
    getUseList () {
      this.$http.getUseList().then(ret => {
        ret.data.map(item => {
          let obj = {
            lable: item.title,
            value: item.cardCount,
            id: item._id
          }
          this.useList.push(obj)
        })
      });
    },
    changeCheck () {
    },
    getGiftDetails() {
      this.$http.getGiftDetails(this.$route.query.id).then(res => {
        for (let item in this.gift) {
          this.gift[item] = res.data[item];
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.$route.query.id) {
            this.edit();
          } else {
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    create() {
      if (this.userInfo.roleValue === 1) {
        this.userFile
          ? (this.gift.user = this.userFile.raw)
          : delete this.gift.user;
      } else {
        delete this.gift.user;
      }
      let form = new FormData();
      let keys = Object.keys(this.gift);
      keys.forEach(key => {
        if (key === "cardHolders") {
          form.append('cardHolders', this.gift.cardHolders)
        } else {
          form.append(key, this.gift[key]);
        }
      });
      this.$http.createGift(form).then(res => {
        this.elMsg(this.$t("alertMsg.addSuccess"), "success");
        this.$router.back();
      });
    },

    edit() {
      let form = new FormData();
      let keys = Object.keys(this.gift);
      keys.forEach(key => {
        form.append(key, this.gift[key]);
      });
      this.$http.updateGift(this.$route.query.id, form).then(res => {
        this.elMsg(this.$t("alertMsg.modifySuccess"), "success");
        this.$router.back();
      });
    }
  },
  mounted() {
    if (!this.$route.query.id) return;
    this.getGiftDetails();
  }
};
</script>

<style lang="scss">
.gift-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
      .gift-mgt-fileName {
        margin-right: 10px;
      }
      .gift-import-btn {
        margin-top: 10px;
      }
    }
    .el-radio {
      margin-right: 10px;
    }
  }
}
</style>
